import {useEffect} from "react";
import { Dispatch } from "redux";
import useTypedNavigate from "../hooks/typed-navigate";
import { usePostHog } from "@posthog/react";
import { useSeo } from "../hooks/useSeo";

interface Props {
  logout: () => (dispatch: Dispatch<AuthenticationAction>) => void;
}

export default function Logout(props: Props) {
  useSeo({ title: "Logging Out", path: "/logout", noindex: true });
  const { logout } = props
  const navigate = useTypedNavigate()
  const posthog = usePostHog()

  useEffect(() => {
    const performLogout = async () => {
      posthog.capture("user_logged_out");
      posthog.reset();
      await logout();
      navigate("/");
    };

    void performLogout();
  }, [logout, navigate, posthog]);

  return <></>
}
